import { useAppDispatch, useDrawerState } from '@core/configureStore';
import { closeDrawer } from '@core/features';
import { Divider, Drawer } from 'antd';
import React, { useMemo } from 'react';
import { ConnectSquareIntegrationButton } from '..';
import { GLOBAL_THEME_COLOR } from '@constants/theme';
import { MIDDLE_STYLE } from '@constants/responsive';

type Props = {};

const AppIntegrationDrawer = (props: Props) => {
  const dispatch = useAppDispatch();
  const { appIntegrationDrawer, extraParams } = useDrawerState();
  const { appId } = useMemo(() => extraParams, [extraParams]);

  const handleClose = () => {
    dispatch(
      closeDrawer({
        drawerName: 'appIntegrationDrawer',
      })
    );
  };

  return (
    <Drawer
      width={500}
      placement="right"
      closable={true}
      onClose={handleClose}
      open={appIntegrationDrawer}>
      {appId === 'SQUARE' && (
        <div style={{ ...MIDDLE_STYLE, flexDirection: 'column' }}>
          <div
            style={{
              width: 70,
              height: 70,
              padding: '10px',
              border: `1px solid ${GLOBAL_THEME_COLOR.$border_color}`,
              borderRadius: 10,
              boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
            }}>
            <img src="square-inc.png" width={'100%'} height={'100%'} alt="Square" />
          </div>
          <h1 style={{ margin: '20px 0px', color: 'black' }}>Square</h1>
          <ConnectSquareIntegrationButton />
          <Divider />
          <div
            style={{
              marginBottom: 20,
              padding: '20px 15px',
              backgroundColor: GLOBAL_THEME_COLOR.$secondary_color,
              borderRadius: 20,
              border: `1px solid ${GLOBAL_THEME_COLOR.$border_color}`,
            }}>
            <p>
              * To allow Review Circle works seamlessly, we recommend you to turn on Instant
              Profiles for the integrated merchant account. Learn more:{' '}
              <a href="https://squareup.com/help/us/en/article/6217-get-started-with-your-customer-directory">
                Customer Directory &gt; Instant Profiles
              </a>
            </p>
          </div>
          <p>
            Review Circle's app for Square makes it easy for businesses to{' '}
            <span style={{ fontWeight: 'bold' }}>collect Google reviews</span>. The app
            automatically sends review invitations to customers after they make a purchase.
          </p>
          <br />
          <p>
            These invitations can be triggered by transactions placed on both{' '}
            <span style={{ fontWeight: 'bold' }}>Square Point of Sale and Invoices</span>. This
            helps businesses collect more reviews, which can improve their online visibility and
            boost customer engagement.
          </p>
        </div>
      )}
    </Drawer>
  );
};

export default AppIntegrationDrawer;
